





































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import WarehouseResortForm from '../WarehouseResortForm/WarehouseResortForm.vue'

import TitleBar from '@/components/Elements/TitleBar.vue'
import moment from 'moment'

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'meta', 'days',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class WarehouseDeliveryApproveList extends Vue {
  public client_id: any = null;
  public deliveryZoneGroup: any = null;
  public deliveryZone: any = null;
  public targetDates: any[] = [];
  public actor!: any;

  get titleStack () {
    return [
      'Подтверждение доставки'
    ]
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'quantity', this.$route.query.sortDirection || 'asc']
  }

  unselectableDates(day: any) {
    return moment().date() > moment(day).date()
  }

  onDatesChange(dates: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  onClientChange(client_id: string) {
    this.$router.replace({
      query: { ...this.$route.query, client_id }
    })
  }

  onZoneGroupChange(delivery_zone_group_id: string) {
    this.$router.replace({
      query: { ...this.$route.query, delivery_zone_group_id }
    })
  }

  onZoneChange(delivery_zone_id: string) {
    this.$router.replace({
      query: { ...this.$route.query, delivery_zone_id }
    })
  }
  onDeliveryApprove(deal_id: any) {
    this.$store.dispatch(`${STORE_KEY}/setDeliveryApprove`, deal_id).then(() => {
        this.handleParamsChange();
      }
    )
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    if (this.$route.query.since) {
      this.targetDates = [
        // @ts-ignore
        moment(this.$route.query.since).toDate(),
        // @ts-ignore
        moment(this.$route.query.until).toDate(),
      ]
    }else {
      this.targetDates = [moment().toDate(), moment().add(1, 'day').toDate()]
    }
    if (this.$route.query.delivery_zone_group_id) {
      this.deliveryZoneGroup = this.$route.query.delivery_zone_group_id
    }
    if (this.$route.query.delivery_zone_id) {
      this.deliveryZone = this.$route.query.delivery_zone_id
    }
    if (this.$route.query.client_id) {
      this.client_id = this.$route.query.client_id
    }
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

}
